import { useFocusEffect } from 'expo-router';
import { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { LocalVoiceRecordingsList } from '@/components/organisms';
import { SettingsSubHeader } from '@/components/organisms/settings/SettingsSubHeader';
import { StorageUsageView } from '@/components/organisms/settings/StorageUsageView';
import { formatFileSize } from '@/formatters/formatFileSize';
import { useTranslation } from '@/i18n';
import { useVoiceRecordingStore } from '@/stores';
import { fontSize, lineHeight, spacing, unisonColors } from '@/theme';

interface StorageSettingsProps {
  readonly onBack: () => void;
}

export const StorageSettings = ({ onBack }: StorageSettingsProps) => {
  const { t } = useTranslation();
  const totalSize = useVoiceRecordingStore((state) => state.upload.totalSize);
  const loadTotalSize = useVoiceRecordingStore((state) => state.loadTotalSize);

  useFocusEffect(
    useCallback(() => {
      void loadTotalSize();
    }, [loadTotalSize]),
  );

  return (
    <>
      <SettingsSubHeader title={t('settings.storage.title')} onBack={onBack} />
      <View testID="storage-settings-content" style={styles.container}>
        <Text testID="storage-description" style={styles.description}>
          {t('settings.storage.description')}
        </Text>
        <View style={styles.section}>
          <StorageUsageView totalSize={formatFileSize(totalSize)} />
          <View testID="recordings-list-container" style={styles.listContainer}>
            <LocalVoiceRecordingsList />
          </View>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: unisonColors.bgNlWeak,
    paddingTop: spacing[4],
    paddingHorizontal: spacing[4],
    gap: spacing[2],
  },
  description: {
    fontSize: fontSize.sm,
    lineHeight: lineHeight.md,
    color: unisonColors.textNdPrimary,
  },
  section: {
    flex: 1,
    gap: spacing[1],
  },
  listContainer: {
    flex: 1,
  },
});
